/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 18th 2022, 7:38:39 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { COLORSCHEME } from "theme/styles";
import { Container } from "@mui/material";
import { CHOOSE_SUBSCRIPTION_SUBTITLE } from "config";
import { useGlobalScope } from "core/providers";
import { SubscriptionPlans } from "saas-subscription/components/SubscriptionPlans";
import { EmphasisText, OSMarketingBanner } from "ui-widgets";

export const SetupBillingStep = ({ label }) => {
  const {
    globalState: { selectedOrganization },
  } = useGlobalScope();

  return selectedOrganization?.id ? (
    <div className="banner-content-style-A">
      <Container maxWidth="lg">
        <h1 style={{ color: COLORSCHEME.primary }}>{label}</h1>
        <div className="banner-cta-style-A">
          <Stack spacing={2}>
            <OSMarketingBanner
              title={
                <>
                  Get Started for absolutely <EmphasisText>free</EmphasisText>!
                </>
              }
              subTitle={<>{CHOOSE_SUBSCRIPTION_SUBTITLE}.</>}
            />
            <Typography className="os-text-limit-length-1" variant="h6" align="center" color="text.secondary">
              Thank you for considering Onestop for <EmphasisText>{selectedOrganization.name}</EmphasisText>. As the
              last step, choose a plan below to get started.
              <br />
              {/* We dont even need your credit card details for the trial. Enjoy! */}
            </Typography>
          </Stack>
          <p>
            <SubscriptionPlans />
          </p>
        </div>
      </Container>
    </div>
  ) : null;
};
